import * as Data from '../api/archibus-v2/DataApi'
import * as Document from '../api/archibus/DocumentApi'

const buildingCache = {}
export const fetchBuilding = ({blId}) => {
  if (buildingCache[blId]) {
    return Promise.resolve(buildingCache[blId])
  }
  let restriction = new Ab.view.Restriction()
  restriction.addClause('bl.bl_id', blId)

  let building = {}
  return Data.getDataFromDataSource(
    'ab-self-service.axvw',
    'buildings',
    restriction
  )
    .then(result => {
      const {data} = result

      if (data && data.length) {
        building = data[0]
      }

      return Promise.resolve(building)
    })
    .then(building => {
      if (building.bldgPhoto) {
        return Document.getTempDocumentUrl('bl', {bl_id: blId}, 'bldg_photo')
      }
    })
    .then(url => {
      if (url) {
        building.url = url
      }

      buildingCache[blId] = {...building}
      return Promise.resolve(building)
    })
}

const buildingFloorsCache = {}

export const fetchBuildingFloors = ({blId}) => {
    let restriction = new Ab.view.Restriction()
    restriction.addClause('fl.bl_id', blId)

    return Data.getDataFromDataSource(
      'ab-self-service.axvw',
      'floors',
      restriction
    ).then(result => {
      const {data} = result

      let floors = data
        .map(record => ({
          bl_id: record.blId,
          fl_id: record.flId,
          fl_name: record.name,
          is_active: record.isActiveSelfSvc,
          ada_fl: record.adaFl,
          ada_dflt_fl: record.adaDfltFl
        }))
        .filter(floor => floor.ada_fl === 'Yes')
        .map(floor => floor.fl_id)
        


      return Promise.resolve(floors)
    })
}

export const fetchAdaFloors = ({blId}) => {
	    let restriction = new Ab.view.Restriction()
	    restriction.addClause('fl.bl_id', blId)

	    return Data.getDataFromDataSource(
	      'ab-self-service.axvw',
	      'floors',
	      restriction
	    ).then(result => {
	      const {data} = result

	      let adaDflt = data
	        .map(record => ({
	          bl_id: record.blId,
	          fl_id: record.flId,
	          fl_name: record.name,
	          is_active: record.isActiveSelfSvc,
	          ada_fl: record.adaFl,
	          ada_dflt_fl: record.adaDfltFl
	        }))
	        .filter(floor => floor.ada_fl === 'Yes')
	        .map(floor => floor.ada_dflt_fl)

	      return Promise.resolve(adaDflt)
	    })
}

export const fetchBuildingAndFloors = async ({blId}) => {
  const [building, floors] = await Promise.all(
    [fetchBuilding, fetchBuildingFloors].map(fn => fn({blId}))
  )

  return {building, floors}
}

export const fetchBuildings = () => {
  let buildings = []
  let restriction = new Ab.view.Restriction()
  restriction.addClause('bl.ada_bldg', 'Yes')
  
  return Data.getDataFromDataSource('ab-self-service.axvw', 'buildings',restriction).then(
    result => {
      const {data} = result
      buildings = data
      let buildingsWithPhotos = data.reduce((acc, item) => {
        if (item.bldgPhoto) {
          acc.push(item.blId)
        }
        return acc
      }, [])

      return Promise.all(
        buildingsWithPhotos.map(blId => {
          return Document.getTempDocumentUrl(
            'bl',
            {bl_id: blId},
            'bldg_photo'
          ).then(url => {
            return Promise.resolve({blId, url})
          })
        })
      ).then(photoUrls => {
        let photoUrlObject = photoUrls.reduce((acc, item) => {
          acc[item.blId] = item
          return acc
        }, {})

        // Add the url to the buildings
        let result = buildings.map(building => {
          const {blId} = building
          building.url = photoUrlObject[blId] ? photoUrlObject[blId].url : null
          return building
        })

        return Promise.resolve(result)
      })
    }
  )
}
